import { outgoingEmailStateModelResource } from '@atlassian/jira-servicedesk-language-settings-translations-resource';
import { useResource } from '@atlassian/react-resource-router';
import type { OutGoingEmailStateModelResponse } from '../../common/types';

export const useOutgoingEmailStateModel = () => {
	const { data, loading, error, refresh } = useResource<OutGoingEmailStateModelResponse>(
		outgoingEmailStateModelResource,
	);

	if (error) {
		return { data: { enabled: false }, loading, error, refresh };
	}

	return { data, loading, error, refresh };
};
